/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import {dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';

const useStyles = makeStyles(() => ({
  header : {
    ...dlsTypography('panelCards'),
    fontFamily    : 'Roboto',
    fontWeight    : '600',
    fontSize      : '14px',
    lineHeight    : '17px',
    textTransform : 'uppercase',
    color         : dlsColor('black'),
    minHeight     : 48
  }
}));

/**
 * A simple component that displays the header for the SpreaderMessageAccordion.
 *
 * ```typescript
 *
 * import SpreaderAccordionHeader from 'ion-suite/src/manufacturer/SpreaderAccordionHeader';
 *
 * <Accordion header={<SpreaderAccordionHeader />}
 * ...
 * />
 *
 * ```
 *
 * @returns The header for the SpreaderMessageAccordion.
 */
const SpreaderAccordionHeader = () => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      {translate('tracking:spreader.header')}
    </div>
  );
};

export default memo(SpreaderAccordionHeader);
